import axios from 'axios';
import { getApiBaseUrl } from './api';
import { getAuthAccessToken } from './demoPreviewStorage';

/** Base URL for video-creator microservice (same-origin `/api/video-creator` behind frontend nginx). */
export function getVideoCreatorBaseUrl() {
  const apiBase = getApiBaseUrl().replace(/\/+$/, '');
  return `${apiBase}/video-creator`;
}

const videoCreatorApi = axios.create({
  headers: { 'Content-Type': 'application/json' },
});

videoCreatorApi.interceptors.request.use((config) => {
  config.baseURL = getVideoCreatorBaseUrl();
  const token = getAuthAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

videoCreatorApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default videoCreatorApi;
